import { forwardRef } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

const SvgFacebookOutlined = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      fill: "currentColor",
      d: "M11.385 18v-7.298h2.446l.366-2.845h-2.812V6.041c0-.823.228-1.384 1.407-1.384l1.504-.001V2.112A20 20 0 0 0 12.105 2C9.937 2 8.452 3.326 8.452 5.76v2.097H6v2.845h2.452V18z"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFacebookOutlined);
var ForwardRef$1 = ForwardRef;

export { ForwardRef$1 as default };
